export default function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[70] focus:px-4 focus:py-2 focus:rounded focus:text-white focus:text-xs focus:font-semibold focus:uppercase focus:tracking-wide"
      style={{
        fontFamily: "'IBM Plex Mono', monospace",
        backgroundColor: "var(--color-brand-primary)",
      }}
    >
      Skip to main content
    </a>
  );
}
